import {isEmpty} from "lodash";

export function lang() {
	let languages = navigator.languages,
		isElectron = navigator.appVersion.indexOf("Electron") > -1;

	return !isElectron && ((languages && !isEmpty(languages) && languages[0].split("-")[0]) || navigator.language.split("-")[0] || "pl") || "pl";
}




// WEBPACK FOOTER //
// ./rapid/languages.js